import { render, staticRenderFns } from "./BottomPoweredBy.vue?vue&type=template&id=dc2f7d3c"
import script from "./BottomPoweredBy.vue?vue&type=script&lang=js"
export * from "./BottomPoweredBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports